export default __webpack_public_path__ + "static/media/IWD.3488da20.png";